import Blue from "~/core";

new Blue({
	name: 'Alert',
	selector: ".alert",
	setup(alert) {
		const header = document.querySelector('.header');
		const alertClose = alert.querySelector('.alert__close');
		const drawer = document.querySelector(".header__drawer");
		
		let name = alert.dataset.name;
		let version = alert.dataset.version;
		let expire = parseInt(alert.dataset.expire);
		let dismissed = `${name}_Alert--dismissed-${version}`;

		if(this.$getCookie(dismissed)) {
			if(this.$browser.name === 'ie') {
				alert.style.display = 'none';
			} else {
				alert.remove();
			}
      setHeightValues();
		}
		else{
			alert.style.display = 'block';
		}

		if(this.$browser.name === 'ie') {
			let ieAlert = document.createElement('div');
			ieAlert.setAttribute('class', 'alert alert--ie');
			ieAlert.innerHTML = `
				<div class="alert__inner">
					<div class="alert__icon ico-warning"></div>
					<div class="alert__message">Internet Explorer version 11 is no longer supported, please try a different browser such as <a href="https://www.google.com/chrome/" class="alert__cta" target="_blank">Google Chrome</a>, <a href="https://www.mozilla.org/en-US/firefox/" class="alert__cta" target="_blank">Mozilla Firefox</a>, or <a href="https://www.microsoft.com/en-us/edge" class="alert__cta" target="_blank">Microsoft Edge</a>.</div>
					<button class="alert__close ico-close" aria-label="Dismiss alert"></button>
				</div>
			`;
			const ieClose = ieAlert.querySelector('.alert__close');
			header.appendChild(ieAlert);
			this.$addEvents(ieClose, 'click.prevent', () => {
				ieAlert.style.display = 'none';
			})
		}

		if(alertClose) {
			this.$addEvents(alertClose, 'click.prevent', () => {
				this.$setCookie(dismissed, true, expire);
				if(this.$browser.name === 'ie') {
					alert.style.display = 'none';
				} else {
					alert.remove();
				}
        setHeightValues();
			});
		}

    function setHeightValues() {
      document.body.style.marginTop = `${header.offsetHeight}px`;
      document.documentElement.style.setProperty(
        "--header-height",
        `${header.offsetHeight}px`
      );
      drawer.style.marginTop = `${header.offsetHeight}px`;
    }
	}
});